import React, { Fragment } from 'react';

import './Brasserie.css';

const Brasserie = ({ brasserie }) => {
  const backgroundStyle = {
    backgroundImage: `url(${brasserie.image.url}`,
  };
  return (
    <Fragment>
      <div className="brasserie-left" style={backgroundStyle} />
      <div className="brasserie-right">
        <img src={brasserie.icone.url} />
        <h2>{brasserie.titre}</h2>
        <p dangerouslySetInnerHTML={{ __html: brasserie.description }} />
      </div>
    </Fragment>
  );
};
export default Brasserie;



// WEBPACK FOOTER //
// ./src/Components/Brasserie/Brasserie.js